<template>
  <div :class="$.filter_tab_item">
    <div :class="$.tabs">
      <vgp-tabs
        :tabs="preparedTabs"
        :active="activeTab"
        :type="'button'"
        gp-autotest-name="gp_autotest_filter_options_tab"
        @onToggle="toggleTab"
      />
    </div>
    <filter-item
      :filter-item="currentItem"
      :readonly="false"
      @changeFilter="data => changeFilter(data)"
    />
  </div>
</template>

<script>
import vgpTabs from '../../common/VueComponents/tabs/vgpTabs.vue';
import filterItem from './filterItem.vue';

export default {
  components: { vgpTabs, filterItem },
  props: {
    filterItems: { type: Array, required: true, default: () => [] },
  },
  emits: {
    changeFilter: Object,
  },
  data() {
    return {
      activeTab: null,
      selectedOptions: [],
    };
  },
  computed: {
    currentItem() {
      return this.filterItems.find(item => item.property === this.activeTab.id);
    },
    preparedTabs() {
      return this.filterItems.map(item => ({
        id: item.property,
        type: item.property,
        title: __(`filter_tab_${item.property}`),
        item,
      }));
    },
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
  },
  watch: {
    currentFilter(filter) {
      if (!filter) {
        return;
      }

      let hasFilter = false;

      this.preparedTabs.forEach(item => {
        const filterValue = filter.properties[item.id];

        if (filterValue && filterValue.length) {
          hasFilter = true;
        }
      });

      if (!hasFilter) {
        this.activeTab = this.preparedTabs[0];
      }
    },
  },
  created() {
    this.activeTab = this.activeByValue() || this.preparedTabs[0];
    this.setSelectedOptions();
  },
  methods: {
    activeByValue() {
      return this.preparedTabs.find(tab => {
        if (tab.item.value && tab.item.value.length) {
          return tab;
        }
      });
    },
    toggleTab(tab) {
      this.activeTab = tab;
      this.setSelectedOptions();
    },
    setSelectedOptions() {
      if (this.filterItem) {
        if (this.filterItem.options && this.filterItem.options.length) {
          this.selectedOptions = this.filterItem.options.filter(opt => opt.selected);
        }
      }
    },
    changeFilter(data) {
      let changes = {};
      let hasNewValues = false;

      Object.values(data).forEach(value => {
        if (value.length) {
          hasNewValues = true;
        }
      });

      if (hasNewValues) {
        this.filterItems.forEach(item => {
          changes[item.property] = '';
        });
      }

      changes = {
        ...changes,
        ...data,
      };

      this.$emit('changeFilter', changes);
    },
  },
};
</script>

<style module='$' lang='less'>
.filter_tab_item {
  .tabs {
    margin-bottom: 8px;
  }
}
</style>
